import { config } from "@/core/modules/config/objects/Config";
import { Theme } from "@/core/modules/theme/objects/Theme";

export const getThemes = (): Theme[] => {
  const themes: Theme[] = config.app.layout.themes;
  return themes;
};
